import { connect } from 'react-redux'

import {
  doSearchLabels,
  doSelectLabel,
  doToggleLabel,
  doFetchTopLabelsForCurrentMailbox,
  doLabelCurrentTicket,
  doCancelCreateLabel,
  doCreateLabelAndAddAsSelected,
} from 'actions/labels'

import {
  selectIsLoadingTopLabels,
  selectIsFetchingLabelSearchResults,
} from 'selectors/app'
import {
  selectIsSearchingLabels,
  selectLabelSearchTerm,
  selectLabelsChanged,
  selectLabelsForBulkEditing,
} from 'selectors/labelings'
import {
  selectIsCreatingALabel,
  selectInitialLabelProps,
} from 'selectors/modals_base'
import { selectCurrentTicketId } from 'selectors/tickets'

import LabelsModal from './view'

const select = state => {
  return {
    hasPendingEdits: selectLabelsChanged(state),
    isCreatingALabel: selectIsCreatingALabel(state),
    isFetchingSearchResults: selectIsFetchingLabelSearchResults(state),
    isLoadingTop: selectIsLoadingTopLabels(state),
    isSearching: selectIsSearchingLabels(state),
    labelToEdit: selectInitialLabelProps(state),
    labels: selectLabelsForBulkEditing(state),
    searchTerm: selectLabelSearchTerm(state),
    ticketId: selectCurrentTicketId(state),
  }
}

const perform = {
  doCancelCreateLabel,
  doToggleLabel,
  onApply: doLabelCurrentTicket,
  onCheckboxChanged: doSelectLabel,
  onModalOpen: doFetchTopLabelsForCurrentMailbox,
  onSearch: doSearchLabels,
  onSave: doCreateLabelAndAddAsSelected,
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    onApply: ownProps.onApply || dispatchProps.onApply,
  }
}

export default connect(select, perform, mergeProps)(LabelsModal)
